import { companyUserSchema } from "@/schema/CompanyUser";
import { z } from "zod";

export const companyUserFormSchema = companyUserSchema
  .omit({
    id: true,
  })
  .extend({
    password: z.string().min(8),
  });

export const companyUserCreateSchema = companyUserFormSchema.extend({
  company_id: z.number(),
});

export const companyUserEditSchema = companyUserSchema.omit({ id: true });

export const companyMemberResetPasswordSchema = z.object({
  password: z.string().min(8),
});

export type CompanyUserForm = z.infer<typeof companyUserFormSchema>;
export type CompanyUserCreate = z.infer<typeof companyUserCreateSchema>;
export type CompanyUserEdit = z.infer<typeof companyUserEditSchema>;
export type CompanyMemberResetPassword = z.infer<
  typeof companyMemberResetPasswordSchema
>;
